<template>
  <div class="wd-box">
  	<div class="wd-box-container" ref="listContainer" @scroll="handleScroll">
  		<div class="wd-user" v-if="data">
  			<img class="wd-user-img" :src="$store.state.userInfo.headPortrait" alt="" />
  			<div class="wd-user-content">
  				<span class="wd-user-content-span">{{$store.state.userInfo.nickName}}</span>
  				<span class="wd-user-content-span1">ID {{data.recodeCode}}</span>
  			</div>
  			<div class="wd-user-edit" @click="handleShowXgzl">
  				<img src="../../../assets/image/xiugaiziliao@2x.png" alt="" />
  				<span>{{$t('all.xiugaiziliao')}}</span>
  			</div>
  		</div>
  		<div class="wd-jb">
  			<div class="wd-jb-left">
  				<div class="wd-jb-left-div">
  					<img src="../../../assets/image/xunibi_32@2x.png" alt="" />
  					<span>US{{$t('all.bi')}}</span>
  				</div>
  				<span class="wd-jb-left-span">{{data?data.virtualBalance:0}}</span>
  			</div>
  			<div class="wd-jb-right" @click="handleShowXfmx">{{$t('all.xiaofeimingxi')}}</div>
  		</div>
		<<div class="wd-box-title">
			<span class="wd-box-title-span">{{$t('all.zhibojilu')}}</span>
			<span class="wd-box-title-span1"></span>
		</div>
  		<div class="wd-box-list">
  			<zbList v-for="(item,index) in list" :key="index" :data="item" :type="1"></zbList>
  		</div>
  		<kong v-if="isKong"></kong>
  	</div>
	<xiaofeimingxi ref="xfmx"/>
	<xiugaiziliao ref="xgzl"/>
  </div>
</template>

<script>
import { getPresentUserInfo } from "@/api/user";
import { getUserLiveRecordList } from "@/api/zhibo";
import zbList from "../../../components/zbList/zbList.vue"
import kong from "../../../components/kong/kong.vue"
import xiaofeimingxi from "../../../components/xiaofeimingxi/xiaofeimingxi.vue"
import xiugaiziliao from "../../../components/xiugaiziliao/xiugaiziliao.vue"
export default {
  components: {
    zbList,
  	kong,
	xiaofeimingxi,
	xiugaiziliao
  },
  data() {
    return {
	  data:'',
	  queryParams:{
	  	page:1,
	  	size:10,
		viewUserId:''
	  },
	  list:[],
	  hasMore: true,
	  isLoading: false,
	  isKong:false,
    };
  },
  mounted() {
	this.$store.commit('changeCount', 4);
	this.getPresentUserInfo()
  },
  methods: {
	async getPresentUserInfo(){
		const res = await getPresentUserInfo()
		this.data = res.data
		this.queryParams.viewUserId = res.data.userId
		this.getUserLiveRecordList()
	},
	// 获取直播记录列表
	async getUserLiveRecordList() {
	  // 3. 如果正在加载或没有更多数据，则直接返回
	  if (this.isLoading || !this.hasMore) {
		return;
	  }
	
	  try {
		// 4. 发起请求前，将加载状态设为 true
		this.isLoading = true;
	
		const response = await getUserLiveRecordList(this.queryParams);
		const newList = response.rows || [];
	
		if (this.queryParams.page === 1) {
		  this.list = newList;
		} else {
		  this.list = [...this.list, ...newList];
		}
	
		const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
		this.hasMore = this.queryParams.page < totalPages;
	    if(response.total == 0){
			this.isKong = true
		}else{
			this.isKong = false
		}
	  } catch (error) {
		console.error("获取直播列表失败:", error);
	  } finally {
		// 5. 请求结束（无论成功或失败），将加载状态恢复为 false
		this.isLoading = false;
	  }
	},
	
	// 滚动事件处理函数
	handleScroll() {
	  // 同样增加 isLoading 判断，防止在请求期间触发
	  if (this.isLoading || !this.hasMore) {
		return;
	  }
	
	  const container = this.$refs.listContainer;
	  // 判断滚动条是否到达底部（或接近底部）
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50; // 50px的缓冲距离
	
	  if (isAtBottom) {
		console.log("滚动到底部，触发加载更多");
		this.queryParams.page++;
		this.getUserLiveRecordList();
	  }
	},
	//显示消费明细
	handleShowXfmx(){
		this.$refs.xfmx.showXfmx()
	},
	//修改资料
	handleShowXgzl(){
		this.$refs.xgzl.showModel()
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./wode.css";
</style>


// WEBPACK FOOTER //
// wode.vue?0483f56b